import { configureStore } from "@reduxjs/toolkit";

import layoutReducer from "Layout/slice";
import authReducer from "features/Auth/slice";
import portfolioReducer from "features/Dashboard/slice";

import strategyReducer from "features/Strategy/slice";
import editorReducer from "features/Strategy/v2/CodeBuilder/slice";
import noCodeBuilderReducer from "features/Strategy/v2/NoCodeBuilder/slice";
import etfBuilderSliceReducer from "features/Strategy/v2/ETFBuilder/slice";

import surmountAccountReducer from "features/SurmountAccount/slice";

import { injectStore } from "services/interceptor";

export const store = configureStore({
  reducer: {
    strategy: strategyReducer,
    portfolio: portfolioReducer,
    auth: authReducer,
    editor: editorReducer,
    layout: layoutReducer,
    noCodeBuilder: noCodeBuilderReducer,
    etfBuilder: etfBuilderSliceReducer,
    surmountAccount: surmountAccountReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

injectStore(store);
